module.exports = __webpack_public_path__ + "67362078b745e9de.svg";